import React from 'react';
import LoveShiftHero from './LoveShiftHero';
import Gatekeeper from './Gatekeeper';
import MirrorOfTruth from './MirrorOfTruth';
import AnnaProof from './AnnaProof';
import JennifersJourney from './JennifersJourney';
import FinalGateway from './FinalGateway';
import LoveShiftFooter from './LoveShiftFooter';

const LoveShift = () => (
  <main className="bg-dark min-h-screen overflow-x-hidden">
    <h1 className="sr-only">
      Love Shift Masterclass – Beziehungsmuster heilen, emotionale Abhängigkeit lösen,
      Affären verstehen, Dualseelen Coach Jennifer Gräser
    </h1>
    <LoveShiftHero />
    <Gatekeeper />
    <MirrorOfTruth />
    <AnnaProof />
    <JennifersJourney />
    <FinalGateway />
    <LoveShiftFooter />
  </main>
);

export default LoveShift;